import { Swiper } from 'swiper/js/swiper.esm';

export {
  Swiper,
};
